import request from '@/services/interceptor.js'

export const get_ricambi = (soloSottoScorta) => {
    return request({
        url: '/ricambio',
        method: 'get',
        params: soloSottoScorta ? { soloSottoScorta: true } : {},
        loadingBar: true
    })
}

export const create_ricambio = (par) => {
    return request({
        url: '/ricambio',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_ricambio = (id, par) => {
    return request({
        url: `/ricambio/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const duplica_ricambio = (id) => {
    return request({
        url: `/ricambio/${id}/duplica`,
        method: 'post',
        loadingBar: true
    })
}

export const delete_ricambio = (id) => {
    return request({
        url: `/ricambio/${id}`,
        method: 'delete',
        loadingBar: true
    })
}